var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "400px",
    width: "400px",
    viewBox: "-175 0 1100 410",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(1,-1) translate(0,-650)",
    horizAdvX: 731,
    d: "M488 375q57-7 98-48t48-98v-195h-536v195q6 57 47 98t98 48h245zM488 472h-244q-49-3-92-23t-76-52.5-53-75.5-23-92v-293h731v293q-3 49-23 92t-52.5 75.5-75.5 52.5-92 23v0 0zM366 862q50 0 86-35.5t36-85.5q0-51-36-86.5t-86-35.5q-51 0-86.5 35.5t-35.5 86.5q0 50 35.5 85.5t86.5 35.5v0zM366 960q-46 0-86-17t-69.5-47-47-70-17.5-85q0-46 17.5-86t47-69.5 69.5-47 86-17.5q45 0 85 17.5t70 47 47 69.5 17 86q0 45-17 85t-47 70-70 47-85 17v0 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHDriver);
export default __webpack_public_path__ + "static/media/h-driver.bc812987f8c575a90788de58be63eb4c.svg";
export { ForwardRef as ReactComponent };